/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs tax assessor info given a list of assessors
//to preserve query uniqueness a list of associated tax impounds in the form of a ImpoundPolicyResponse array is to be provided as well
import { QueryFunctionContext, useQueries } from '@tanstack/react-query';
import { fetchTaxPayeeInfo, ImpoundPolicyListResponse } from '../queryFunctions';

const useTaxPayeeInfo = (assessorCodes: Set<string>, taxImpounds: ImpoundPolicyListResponse[], token: string) => {
  return useQueries({
    queries: [...assessorCodes].map((assessorCode, index) => ({
      queryKey: [index, assessorCodes, taxImpounds, token, 'taxPayeeInfo'],
      queryFn: ({ signal }: QueryFunctionContext) => fetchTaxPayeeInfo(signal, token, assessorCode),
      refetchOnWindowFocus: false,
    })),
    combine: (results) => {
      return {
        data: results.map((result) => result.data),
        status: results.some((result) => result.isPending)
          ? 'pending'
          : results.some((result) => result.isError)
            ? 'error'
            : 'success',
        error: results.filter((result) => result.isError).map((result) => result.error),
      };
    },
  });
};
export default useTaxPayeeInfo;
